import {XHTTP} from '@/shared/xhttp';
import {TempService} from "@/xhttp/TempService";
import {Client} from "@/models/Client";
import {Tache} from "@/models/Tache";
import {Projet} from "@/models/Projet";
import {User} from "@/models/User";
import {DateHelper} from "@/shared/utils";

@XHTTP(TempService, '/temps')
export class Temp {

	private _id: number;
	private _date: Date = new Date();
	private _client: Client;
	private _projet: Projet;
	private _tache: Tache;
	private _description: string;
	private _duration: number;
	private _aFacturer: boolean = true;
	private _user: User;
	private _nameProjet: string;
	private _nameClient: string;
	private _nameTache: string;
	private _descriptionTache: string;
	private _nameUser: string;
	private _createdAt: Date;

	/////////////
	// Getters //
	/////////////

	public get id(): number {
		return this._id;
	}

	public get date(): Date {
		return this._date;
	}

	public get client(): Client {
		return this._client;
	}

	public get projet(): Projet {
		return this._projet;
	}

	public get tache(): Tache {
		return this._tache;
	}

	public get description(): string {
		return this._description;
	}

	public get duration(): number {
		return this._duration;
	}

	public get aFacturer(): boolean {
		return this._aFacturer;
	}

	public get user(): User {
		return this._user;
	}

	public get nameProjet(): string {
		return this._nameProjet;
	}

	public get nameClient(): string {
		return this._nameClient;
	}

	public get nameTache(): string {
		return this._nameTache;
	}

	public get descriptionTache(): string {
		return this._descriptionTache;
	}

	public get nameUser(): string {
		return this._nameUser;
	}

	public get createdAt(): Date {
		return this._createdAt;
	}

	/////////////
	// Setters //
	/////////////

	public set id(value: number) {
		this._id = value;
	}

	public set date(value: Date) {
		this._date = value;
	}

	public set client(value: Client) {
		this._client = value;
	}

	public set projet(value: Projet) {
		this._projet = value;
	}

	public set tache(value: Tache) {
		this._tache = value;
	}

	public set description(value: string) {
		this._description = value;
	}

	public set duration(value: number) {
		this._duration = value;
	}

	public set aFacturer(value: boolean) {
		this._aFacturer = value;
	}

	public set user(value: User) {
		this._user = value;
	}

	public set nameProjet(value: string) {
		this._nameProjet = value;
	}

	public set nameClient(value: string) {
		this._nameClient = value;
	}

	public set nameTache(value: string) {
		this._nameTache = value;
	}

	public set descriptionTache(value: string) {
		this._descriptionTache = value;
	}

	public set nameUser(value: string) {
		this._nameUser = value;
	}

	///////////////
	// Serialize //
	///////////////+

	public toJSON(): any {
		return {
			id       : this._id,
			date    : this._date ? DateHelper.toLocalizedStringWithTimeZero(this._date) : null,
			client  : this._client ? this._client.id : null,
			projet  : this._projet ? this._projet.id : null,
			tache  : this._tache ? this._tache.id : null,
			description     : this._description,
			duration  : this._duration,
			user  : this._user ? this._user.id : null,
			nameProjet     : this._nameProjet,
			nameClient     : this._nameClient,
			nameTache     : this._nameTache,
			descriptionTache     : this._descriptionTache,
			nameUser     : this._nameUser,
			aFacturer     : this._aFacturer,
		};
	}

	public fromJSON(data: any): this {
		this._id        = data.id;
		this._date         = data.date ? DateHelper.fromLocalizedString(data.date) : null;
		this._client    = data.client ? (new Client()).fromJSON(data.client) : null;
		this._projet    = data.projet ? (new Projet()).fromJSON(data.projet) : null;
		this._tache    = data.tache ? (new Tache()).fromJSON(data.tache) : null;
		this._description      = data.description;
		this._duration   = data.duration;
		this._user    = data.user ? (new User()).fromJSON(data.user) : null;
		this._createdAt                  = data.createdAt ? new Date(data.createdAt) : null;
		this._nameProjet      = data.nameProjet;
		this._nameClient      = data.nameClient;
		this._nameTache      = data.nameTache;
		this._descriptionTache      = data.descriptionTache;
		this._nameUser      = data.nameUser;
		this._aFacturer      = data.aFacturer;
		return this;
	}
}